/* tslint:disable */
/* eslint-disable */
export enum PermissionType {
  $1 = 1
}
